import cx from 'classnames';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar';
import GroupName from 'groups/components/GroupName';
import * as React from 'react';
import GroupDataOps from 'groups/lib/GroupDataOps';

import './styles/JoinAvatarPanel.scss';

import { Props as AvatarProps } from 'groups/components/GroupAvatar';
import { Props as GroupNameProps } from 'groups/components/GroupName';
import { LoadNonV2GroupByUUID_nonV2Class } from 'groups/queries/__generated__/LoadNonV2GroupByUUID';

type Props = {
  group: Group | LoadNonV2GroupByUUID_nonV2Class;
} & AvatarProps &
  GroupNameProps;

class JoinGroupAvatarPanel extends React.Component<Props> {
  render() {
    const { group } = this.props;

    return (
      <div className={cx('JoinAvatarPanel', this.props.className)}>
        <div className="JoinAvatarPanel-Image">
          <GroupAvatar group={this.props.group} />
        </div>

        <div className="JoinAvatarPanel-Header">
          <h4>
            <p>{GroupDataOps.getPossessiveSignature(group)}</p>
            <strong>
              <GroupName group={group} />
            </strong>
          </h4>
        </div>

        <div className="JoinAvatarPanel-Footer">
          <div>{GroupDataOps.getOrganizationName(group)}</div>
          <div>@{GroupDataOps.getCodeOrError(group)}</div>
        </div>
      </div>
    );
  }
}

export default JoinGroupAvatarPanel;
